<template>
  <div>
    <NavTop :parentData="this.$route.params.tabBarId" class="navbar"></NavTop>
    <!-- 动态公告 -->
    <div class="deptNews content">
      <div class="deptNews_box">
        <div class="deptNews_box_left">
          <span>{{ title.childName }}</span>
          <span style="font-size: 14px;cursor: pointer" v-if="title.appointTabId != null" @click="goTiaoZhuan(title.appointTabId)">
              查看更多
            </span>
          <span style="font-size: 14px;cursor: pointer" v-else @click="goTiaoZhuanSpan(title.parentId,title.id)">查看更多</span>
        </div>
        <div class="deptNews_box_right">
          <div class="deptNews_box_right_swiper">
            <swiper class="swiper4" :options="swiperOptions4">
              <swiper-slide class="swiper_img4" v-for="(slide, index) in time" :key="index">
                <div class="swiper_img4_lefttop">
                  <span>{{ $extractDateTime(slide.createTime) }}</span>
                  <span>{{ $extractDateList(slide.createTime) }}</span>
                </div>
                <img :src="slide.url" alt="Slide Image" @click="routerpush(title.parentId,slide.tabBarId,slide.id,)">
                <div class="swiper_img4_title">
                  <span>{{ slide.title }}</span>
                </div>
              </swiper-slide>
              <div class="swiper-pagination4" slot="pagination"></div>
            </swiper>
          </div>
          <div class="deptNews_box_right_list">
            <ul class="deptNews_box_right_list_ul">
              <li class="deptNews_box_right_list_ul_li" style="cursor: pointer" v-for="(item,index) in title.articleList" :key="index">
                <span class="list_ul_li_a1" v-if="title.appointTabId == null"
                      @click="routerpush(title.parentId,item.tabBarId,item.id)">{{ item.title }}</span>
                <span class="list_ul_li_a1" v-else @click="routerpushSpan(title.appointTabId, item.id)">{{
                    item.title
                  }}</span>
                <span class="list_ul_li_span">{{ $extractDate(item.publishTime) }}</span>
              </li>
            </ul>
          </div>
        </div>
      </div>
      <!-- 通知公告 -->
      <div class="deptNews_tongZ">
        <div class="deptNews_tongZ_title">
          <span>{{ dept_list.childName }}</span>
          <span style="font-size: 14px;cursor: pointer" v-if="dept_list.appointTabId != null"
                @click="goTiaoZhuan(dept_list.appointTabId)">
              查看更多
            </span>
          <span style="font-size: 14px;cursor: pointer" v-else
                @click="goTiaoZhuanSpan(dept_list.parentId,dept_list.id)">查看更多</span>
        </div>
        <div class="deptNews_tongZ_list">
          <ul class="deptNews_tongZ_list_ul">
            <li class="deptNews_tongZ_list_ul_li" style="cursor: pointer" v-for="(item,index) in dept_list.articleList" :key="index">
              <a href="">
                <span class="list_ul_li_a1" v-if="title.appointTabId == null"
                      @click="routerpush(title.parentId,item.tabBarId,item.id)">{{ item.title }}</span>
                <span class="list_ul_li_a1" v-else @click="routerpushSpan(title.appointTabId, item.id)">{{
                    item.title
                  }}</span>
              </a>
            </li>
          </ul>
        </div>
      </div>
    </div>
    <!-- 图片 -->
    <div class="edu_pic">
      <!--      <div class="edu_picV">-->
      <!--        <span @click="navWai('https://www.xybsyw.com')">实习管理平台</span>-->
      <!--        <span @click="navWai('https://mooc1.chaoxing.com/course/243604863.html')">实验室安全教育课程</span>-->
      <!--      </div>-->
    </div>
    <!-- 通知公告 -->
    <div class="notice">
      <div class="notice_ content">
        <div class="notice_con" v-for="(item,index) in noticeData" :key="index">
          <div class="notice_con_title">
            <span>{{ item.childName }}</span>
            <span style="font-size: 14px;cursor: pointer" v-if="item.appointTabId != null"
                  @click="goTiaoZhuan(item.appointTabId)">
              查看更多
            </span>
            <span style="font-size: 14px;cursor: pointer" v-else
                  @click="goTiaoZhuanSpan(item.parentId,item.id)">查看更多</span>
          </div>
          <div class="notice_con_list">
            <ul class="notice_con_list_ul">
              <li class="notice_con_list_ul_li" v-for="(item1,index1) in item.articleList" :key="index1">
                <div class="notice_con_list_ul_li_a" style="cursor: pointer">
                  <span v-if="title.appointTabId == null"
                        @click="routerpush(title.parentId,item1.tabBarId,item1.id)">{{ item1.title }}</span>
                  <span v-else @click="routerpushSpan(title.appointTabId, item1.id)">{{ item1.title }}</span>
                </div>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
// import home from '../../api/home'
import child from '../../api/child'
import home from '../../api/home'

export default {
  data () {
    return {
      swiperOptions4: {
        pagination: {el: '.swiper-pagination4', clickable: true},
        navigation: {nextEl: '.swiper-button-next', prevEl: '.swiper-button-prev'},
        loop: true,
        autoplay: {
          delay: 2500,
          stopOnLastSlide: false,
          disableOnInteraction: false
        },
        speed: 2000
      },
      // 轮播图
      title: [],
      time: [],
      bannerImg: [],
      // 部门新闻列表
      dept_list: [],
      // 通知公告数据
      noticeData: [],
      // 支部建设数据
      zhibuData: [],
      // 团学活动数据
      tuanxueData: [],
      currentIndexBanner: 0 // banner轮播图
    }
  },
  mounted () {
    this.getWenZhang(this.$route.params.tabBarId)
    this.getBannerList('/dept')

  },
  methods: {
    async getBannerList (bannerPath) {
      const res = await home.getBanner({
        bannerPath
      })
      console.log(res)
      this.time = res.rows
      console.log(this.time)
    },
    // 跳转外连
    navWai (path) {
      window.open(path, '_blank')
    },
    // 正常跳转
    navigateTo (path) {
      this.$router.push(path)
    },
    handleCarouselChange (index) {
      this.currentIndexBanner = index
    },

    // 导航栏
    async getWenZhang (tabBarId) {
      const res = await child.getChild({tabBarId: tabBarId})
      if (res.code == 200) {
        const data = res.data
        console.log('导航栏', data)
        this.title = data[0]
        this.dept_list = data[1]
        // 通知公告数据
        this.noticeData = data.slice(2, 5)
        console.log(this.noticeData)
      }
    },

    // 截取日期
    extractDate(dateTimeStr) {
      // 使用空格分割日期和时间
      if (dateTimeStr) {
        const parts = dateTimeStr.split(' ')
        // 返回日期部分
        return parts[0]
      }
    },
    extractDateTime(dateTimeStr) {
      if (dateTimeStr) {
        // 使用空格分割日期和时间
        const parts = dateTimeStr.split('-')
        const resultFen = parts[2].split(' ')
        const result = resultFen.slice(0, 1).join('-')
        // 返回日期部分
        return result
      }
    },
    extractDateList(dateTimeStr) {
      if (dateTimeStr) {
        // 使用空格分割日期和时间
        const parts = dateTimeStr.split('-')
        console.log(parts)
        const result = parts.slice(0, 2).join('-')
        // 返回日期部分
        return result
      }
    },
    goGengD (parentId, id) {
      this.$router.push({
        path: '/common/section/more' + '/' + parentId + '/' + id
      })
    },
    // 点击上方查看更多
    goTiaoZhuan (appointTabId) {
      let encodedId = encodeURIComponent(appointTabId)
      let decodedId = decodeURIComponent(encodedId)
      this.$router.push('/common/section/more' + decodedId)
    },
    goTiaoZhuanSpan (parentId, id) {
      this.$router.push('/common/section/more' + '/' + parentId + '/' + id)
    },
    routerpush (parentId, tabBarId, id) {
      this.$router.push('/common/section/detail' + '/' + parentId + '/' + tabBarId + '/' + id)
    },
    routerpushSpan (appointTabId, id) {
      let encodedId = encodeURIComponent(appointTabId)
      let decodedId = decodeURIComponent(encodedId)
      this.$router.push('/common/section/detail' + decodedId + '/' + id)
    },
  }
}
</script>
<style lang="less" scoped>
ul, li {
  list-style: none;
  color: #FFFFFF;
}

.edu_pic {
  background: #f9f9f9;
  padding-top: 40px !important;

  .edu_picV {
    display: flex;
    justify-content: space-around;
    align-items: center;
    padding: 0 200px;

    span {
      cursor: pointer;
      display: grid;
      place-content: center;
      width: 180px;
      height: 45px;
      border-radius: 8px;
      border: solid 1px #ccc;

      &:hover {
        background-color: #ff1212;
        color: #fff;
      }
    }
  }
}

a {
  text-decoration: none !important;
}

.lunb {
  overflow: hidden;

  .lunb_con {
    width: 100%;
    height: 45px;
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: rgba(0, 0, 0, 0.4);
    transform: translateY(-125px);
    font-size: 15px;
    color: #FFFFFF;

    span {
      //transform: translateX(-20px);
    }
  }
}

.banner_carousel {
  position: relative;
}

// 部门新闻
.deptNews {
  width: 100%;
  height: 370px;
  padding-top: 10px;
  display: flex;
  justify-content: space-between;
  margin-top: 20px !important;

  .deptNews_box {
    width: 800px;
    height: 370px;

    .deptNews_box_left {
      border-bottom: 1px solid #eee;
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-bottom: 10px;

      span {
        font-size: 24px;
        color: #444;
        line-height: 50px;
        position: relative;

        &::after {
          content: "";
          position: absolute;
          left: 0;
          right: 0;
          bottom: 0;
          height: 2px;
          background: #9e070e;
        }
      }

      a {
        text-decoration: none;
        color: #666;
        position: relative;
        line-height: 40px;
        font-size: 14px;
      }
    }

    .deptNews_box_right {
      height: 280px;
      display: flex;
      justify-content: space-between;
      align-items: center;

      .deptNews_box_right_swiper {
        width: 400px;
        height: 280px;
        overflow: hidden;
        position: relative;

        .banner_carousel {
          overflow: hidden;
        }
      }

      .deptNews_box_right_list {
        width: 365px;
        height: 280px;

        .deptNews_box_right_list_ul {
          width: 100%;
          height: 100%;
          overflow: hidden;

          .deptNews_box_right_list_ul_li {
            height: 60px;
            line-height: 60px;
            border-bottom: 1px solid #eee;
            display: flex;
            justify-content: space-between;
            align-items: center;

            .list_ul_li_a1 {
              display: block;
              width: 80%;
              padding-left: 20px;
              overflow: hidden;
              text-overflow: ellipsis;
              white-space: nowrap;
              text-decoration: none;
              color: #444;
              font-size: 14px;
              position: relative;


              &:hover {
                color: #AB330E;
              }
            }

            .list_ul_li_a2 {
              width: 20px;
              height: 20px;
              display: inline-block;
              line-height: 20px;

              img {
                width: 100%;
              }
            }

            .list_ul_li_span {
              font-size: 12px;
              color: #999;
            }
          }
        }
      }
    }
  }

  // 通知公告
  .deptNews_tongZ {
    width: 375px;
    height: 340px;
    border: 1px solid #eee;

    .deptNews_tongZ_title {
      padding: 0 20px;
      height: 50px;
      display: flex;
      justify-content: space-between;
      align-items: center;

      span {
        font-size: 28px;
        color: #444;
        line-height: 54px;
        position: relative;

        &::after {
          content: "";
          position: absolute;
          width: 100%;
          height: 2px;
          background: #8d080e;
          bottom: 2px;
          left: 0;
        }
      }

      a {
        color: #666;
      }
    }

    .deptNews_tongZ_list {
      height: 280px;
      padding: 0 20px;
      overflow: hidden;

      .deptNews_tongZ_list_ul {
        width: 100%;
        height: 100%;
        padding-top: 10px;

        .deptNews_tongZ_list_ul_li {
          height: 45px;
          padding-left: 20px;
          position: relative;
          border-bottom: 1px solid #eee;
          line-height: 45px;

          a {
            color: #333;
            display: block;
            text-decoration: none;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
            font-size: 15px;

            &:hover {
              color: #7c2c2c;
            }

            &::after {
              content: "";
              position: absolute;
              width: 5px;
              height: 5px;
              background: #8d080e;
              border-radius: 50%;
              left: 0;
              top: 50%;
            }
          }
        }
      }
    }
  }
}

// 通知公告
.notice {
  background: #f9f9f9;
  height: 465px;

  .notice_ {
    display: flex;
    justify-content: space-between;
    align-items: center;
    height: 430px;

    .notice_con {
      width: 375px;
      height: 350px;
      border: 1px solid #eee;
      background: #fff;

      .notice_con_title {
        padding: 0 20px;
        height: 50px;
        display: flex;
        justify-content: space-between;
        align-items: center;

        span {
          font-size: 24px;
          color: #444;
          line-height: 54px;
          position: relative;

          &::after {
            content: "";
            position: absolute;
            width: 100%;
            height: 2px;
            background: #8d080e;
            bottom: 2px;
            left: 0;
          }
        }

        a {
          color: #666666;

          &:hover {
            color: #7c2c2c;
          }
        }
      }

      .notice_con_list {
        height: 280px;
        padding: 0 20px;
        overflow: hidden;

        .notice_con_list_ul {
          width: 100%;
          height: 100%;
          padding-top: 10px;

          .notice_con_list_ul_li {
            height: 45px;
            padding-left: 20px;
            position: relative;
            border-bottom: 1px solid #eee;
            line-height: 45px;
            display: flex;
            justify-content: space-around;
            align-items: center;

            &::after {
              content: "";
              position: absolute;
              width: 5px;
              height: 5px;
              background: #8d080e;
              border-radius: 50%;
              left: 0;
              top: 50%;
            }

            .notice_con_list_ul_li_a {
              width: 100%;
              color: #333;
              display: block;
              text-decoration: none;
              overflow: hidden;
              text-overflow: ellipsis;
              white-space: nowrap;
              font-size: 15px;

              &:hover {
                color: #7c2c2c;
              }
            }
          }
        }
      }
    }
  }
}


div {
  box-sizing: border-box !important;
}

.active {
  span {
    color: #8D0835 !important;
  }
}

.content {
  width: 1200px;
  margin: 0 auto;
}

.nav {
  &:hover {
    background-color: #9E070E;
  }
}

.dropdown_menu {
  .dropdown_menu1 {
    div {
      color: #000;

      &:hover {
        color: #fff;
      }
    }
  }
}

@media (max-width: 768px) {
  .container {
    flex-direction: column;
  }

  .sidebar {
    width: 100%;
    text-align: center;
  }

  .content {
    padding-left: 0;
  }
}

</style>
<style lang="less" scoped>
.swiper4 {
  width: 400px;
  height: 280px;
  overflow: hidden;
  position: relative;

  .swiper_img4 {
    cursor: pointer;
    position: relative;

    .swiper_img4_lefttop {
      position: absolute;
      width: 62px;
      height: 62px;
      background-color: #990000;
      top: 15px;
      left: 15px;

      span {
        &:nth-child(1) {
          display: inline-block;
          color: #fff;
          font-size: 24px;
          font-weight: bold;
          width: 62px;
          text-align: center;
          line-height: 38px;
        }

        &:nth-child(2) {
          display: inline-block;
          width: 62px;
          color: #fff;
          font-size: 14px;
          text-align: center;
        }
      }
    }

    .swiper_img4_title {
      height: 30px;
      position: absolute;
      bottom: 0;
      left: 0;
      right: 0;
      background: rgba(0, 0, 0, 0.5);

      span {
        display: inline-block;
        width: 60%;
        font-size: 14px;
        overflow: hidden;
        color: #fff;
        text-overflow: ellipsis;
        white-space: nowrap;
        line-height: 30px;
        margin-left: 30px;
      }
    }

    img {
      width: 100%;
      height: 100%;
    }
  }
}

.swiper-pagination4 {
  position: absolute;
  bottom: 10px;
  left: 0;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  z-index: 9999;
  width: 380px !important;
  height: 16px;

  /* 未选中时的分页器子弹样式 */

  .swiper-pagination-bullet {
    width: 8px;
    height: 8px;
    display: inline-block;
    border-radius: 100%;
    border: 1px solid #fff !important;
    opacity: 1 !important;
    background: transparent !important;
    margin: 0 4px;
    box-sizing: content-box !important;
  }

  /* 选中时的分页器子弹样式 */

  .swiper-pagination-bullet.swiper-pagination-bullet-active {
    margin: 0 4px;
    background: #8d080e !important;
    border: 1px solid #fff !important;
    opacity: 1 !important;
    width: 8px;
    height: 8px;
    display: inline-block;
    border-radius: 100%;
    box-sizing: content-box !important;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/dept/dept.vue